export default "/_next/static/images/42ef8f1f702eb8eb2faaaf615a25b18d.jpg";